import { withBemMod } from '@bem-react/core';

import { cnButton } from '../../Button.cn';

import './Button_view_primary.css';

export type WithViewPrimaryProps = {
    view?: 'primary';
};

export const withViewPrimary = withBemMod<WithViewPrimaryProps>(cnButton(), {});
